import React from 'react';
import { useNavigate } from 'react-router-dom';
import { truncateData } from '../../services';
import StyledTooltip from '../tooltip';

function BreadCrumbs() {
  const navigate = useNavigate();
  const urlParams = new URLSearchParams(window.location.search);

  const handleNavigate = (route: string) => {
    const userId = urlParams.get('session_id');
    if (userId) {
      navigate(`${route}?session_id=${userId}`);
    } else {
      navigate(`${route}`);
    }
  };

  const capitalizeAndConvert = (value: string) => {
    const words = value?.split(/[-]/); // Split by both hyphen and underscore
    for (let i = 0; i < words.length; i += 1) {
      words[i] = words[i].charAt(0).toUpperCase() + words[i].slice(1);
    }
    return words.join(' ');
  };

  const pathSegments = window.location.pathname.includes('/automator/workflow')
    ? ['automator', 'workflow'] // Extract only 'automator' and 'workflow'
    : window.location.pathname.split('/').filter(Boolean);

  const renderBreadcrumbItem = (segment: string, index: number) => {
    const route = `/${pathSegments.slice(0, index + 1).join('/')}`;
    const isLast = index === pathSegments.length - 1;
    const isFirst = index === 0;
    const displayText = truncateData(capitalizeAndConvert(segment), 30);

    const button = (
      <button
        type="button"
        className={`text-sm font-normal hover:cursor-pointer ${
          !isLast ? 'hover:underline text-[#667085]' : 'text-[#EF7707]'
        }`}
        onClick={() => !isLast && handleNavigate(route)}
      >
        {displayText}
      </button>
    );

    return (
      <React.Fragment key={route}>
        {!isFirst ? (
          button
        ) : (
          <StyledTooltip placement="top" title={capitalizeAndConvert(segment)}>
            {button}
          </StyledTooltip>
        )}
        {!isLast && (
          <ol className="bread-list inline-flex items-center space-x-1 md:space-x-2 rtl:space-x-reverse">
            <li aria-current="page">
              <svg
                className="rtl:rotate-180 w-3 h-3 text-gray-400 mx-1"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 6 10"
              >
                <path
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="m1 9 4-4-4-4"
                />
              </svg>
            </li>
          </ol>
        )}
      </React.Fragment>
    );
  };

  return (
    <div className="flex gap-1 items-center">
      {pathSegments.map((segment, index) => renderBreadcrumbItem(segment, index))}
    </div>
  );
}

export default BreadCrumbs;
